/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sarahs_ClosetInputs */

const en_sarahs_closet = /** @type {(inputs: Sarahs_ClosetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@sarahs_closet`)
};

const es_sarahs_closet = /** @type {(inputs: Sarahs_ClosetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@armario_de_sara`)
};

const fr_sarahs_closet = /** @type {(inputs: Sarahs_ClosetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@le_dressing_de_sarah`)
};

const de_sarahs_closet = /** @type {(inputs: Sarahs_ClosetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@sarahs_schrank`)
};

const ja_sarahs_closet = /** @type {(inputs: Sarahs_ClosetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@sarahs_closet`)
};

const zh_sarahs_closet = /** @type {(inputs: Sarahs_ClosetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@sarahs_closet`)
};

const ar_sarahs_closet = /** @type {(inputs: Sarahs_ClosetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@sarahs_closet`)
};

const id_sarahs_closet = /** @type {(inputs: Sarahs_ClosetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@lemarisarah`)
};

const it_sarahs_closet = /** @type {(inputs: Sarahs_ClosetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@armadio_di_sara`)
};

const ru_sarahs_closet = /** @type {(inputs: Sarahs_ClosetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@sarahs_closet`)
};

const pt_sarahs_closet = /** @type {(inputs: Sarahs_ClosetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@armario_da_sarah`)
};

const ko_sarahs_closet = /** @type {(inputs: Sarahs_ClosetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`@sarahs_closet`)
};

/**
* | output |
* | --- |
* | "@sarahs_closet" |
*
* @param {Sarahs_ClosetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sarahs_closet = /** @type {((inputs?: Sarahs_ClosetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sarahs_ClosetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sarahs_closet(inputs)
	if (locale === "es") return es_sarahs_closet(inputs)
	if (locale === "fr") return fr_sarahs_closet(inputs)
	if (locale === "de") return de_sarahs_closet(inputs)
	if (locale === "ja") return ja_sarahs_closet(inputs)
	if (locale === "zh") return zh_sarahs_closet(inputs)
	if (locale === "ar") return ar_sarahs_closet(inputs)
	if (locale === "id") return id_sarahs_closet(inputs)
	if (locale === "it") return it_sarahs_closet(inputs)
	if (locale === "ru") return ru_sarahs_closet(inputs)
	if (locale === "pt") return pt_sarahs_closet(inputs)
	return ko_sarahs_closet(inputs)
});